// Convert file to base64 string
export const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = (error) => {
            reject(error);
        };
    });
};
//Get base64 from Blob and pass to callback
export const getBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(file);
};
// Check if two objects have changes
export const hasChanges = (initialValues, newValues) => {
    return JSON.stringify(initialValues) !== JSON.stringify(newValues);
};
// Get UTC offset string
export const getUtcOffset = () => {
    const offset = new Intl.DateTimeFormat('en-US', {
        timeZoneName: 'short',
    })
        .formatToParts(new Date())
        .find((part) => part.type === 'timeZoneName')?.value;
    return offset ? offset.replace(/GMT/g, '') : '';
};
